import $ from 'jquery';
import * as Website from '../Config/Website.js';

const init = () => {
  $('.js-accordion').each(function() {
    if($(this).hasClass(Website.classList.actOpen)) {
      $(this).next().show().addClass(Website.classList.actOpen);
    }
  });
  $('.js-accordionSP').each(function() {
    if($(this).hasClass(Website.classList.actOpen) && Website.status.winWidth < Website.options.shiftpoint) {
      $(this).next().show().addClass(Website.classList.actOpen);
    }
  });

  $(document).on('click', '.js-accordion', function() {
    $(this).toggleClass(Website.classList.actOpen);
    $(this).next().slideToggle(300).toggleClass(Website.classList.actOpen);
  });

  $(document).on('click', '.js-accordionSP', function() {
    if( Website.status.winWidth < Website.options.shiftpoint ) {
      $(this).toggleClass(Website.classList.actOpen);
      $(this).next().slideToggle(300,).toggleClass(Website.classList.actOpen);
    }
  }); 

  document.addEventListener('click', (e) => {
    let target = null;
    if(e.target.closest('.js-accordionCSS')) {
      target = e.target.closest('.js-accordionCSS');
    } else if(e.target.matches('.js-accordionCSS')) {
      target = e.target;
    }
    if(target) {
      let targetElm = target.nextElementSibling;
      if(target.dataset.accordion) {
        targetElm = document.getElementById(target.dataset.accordion);
      }
      target.classList.toggle(Website.classList.actOpen);
      if(targetElm) {
        targetElm.classList.toggle(Website.classList.actOpen);
      }
    } 
  });
}

const css = () => {
  const triggerElms = document.getElementsByClassName('js-accordionCSS');
  if(triggerElms.length === 0) return;
  for(const triggerElm of triggerElms) {
    let targetElm = triggerElm.nextElementSibling;
    if(triggerElm.dataset.accordion) {
      targetElm = document.getElementById(triggerElm.dataset.accordion);
    }
    if(!targetElm) return;
    const targetElmHeight = targetElm.scrollHeight;

    targetElm.style.setProperty('--h', targetElmHeight + 'px');
  }
}

export {
  init, 
  css
}